import { type FileType, FileTypeMimeTypeMap } from '../const/fileTypes';

export const getMimeTypesForFiles = (...fileTypes: FileType[]) => {
	let result: string[] = [];

	fileTypes.forEach((type) => {
		result = [...result, ...FileTypeMimeTypeMap[type]];
	});

	return result;
};
